import MenuAbilities from './MenuAbilities';

export default MenuAbilities;
